import { Component, inject, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error404',
    templateUrl: './error404.component.html',
    styleUrls: ['./error404.component.scss'],
    standalone: false
})
export class Error404Component implements OnInit {

  public readonly settings = inject(SettingsService);
  private readonly router = inject(Router);

  ngOnInit(): void { }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
